import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// Example: using React Icons for a question icon
import { QuestionCircleOutlined } from '@ant-design/icons';
import './AskSLAI.css';

const AskSLAI = () => {
    const [isOpen, setIsOpen] = useState(false);

    // Placeholder chat messages
    const [messageInput, setMessageInput] = useState('');
    const [messages, setMessages] = useState([
        { role: 'assistant', content: 'Hello! How can I help you today?' },
    ]);

    // Controls the pulsate animation on route changes
    const [animate, setAnimate] = useState(false);

    // Trigger pulsate whenever location changes (user navigates) or page refresh
    const location = useLocation();
    useEffect(() => {
        setAnimate(true);
    }, [location]);

    // Stop pulsating after animation completes
    const handleAnimationEnd = () => {
        setAnimate(false);
    };

    // Open or close the chat
    const openChat = () => setIsOpen(true);
    const closeChat = () => setIsOpen(false);

    // Send message
    const handleSend = () => {
        if (!messageInput.trim()) return;

        const newMessage = {
            role: 'user',
            content: messageInput.trim(),
        };
        setMessages([...messages, newMessage]);
        setMessageInput('');

        // Hook up your AI or backend here if desired...
    };

    return (
        <>
            {/*
                The round icon button, displayed ONLY if chat is NOT open.
                Twirls on hover & can pulsate on route change.
            */}
            {!isOpen && (
                <button
                    className={`ask-slai-button ${animate ? 'pulsate' : ''}`}
                    onClick={openChat}
                    onAnimationEnd={handleAnimationEnd}
                >
                    <QuestionCircleOutlined size={20} />
                </button>
            )}

            {/* Chat Dialog in bottom-right corner */}
            {isOpen && (
                <div className="slai-chat-dialog">
                    <div className="slai-chat-header">
                        <span>Ask SLAI</span>
                        <button className="slai-chat-close" onClick={closeChat}>
                            &times;
                        </button>
                    </div>

                    <div className="slai-chat-messages">
                        {messages.map((msg, idx) => (
                            <div
                                key={idx}
                                className={
                                    msg.role === 'assistant'
                                        ? 'slai-message assistant'
                                        : 'slai-message user'
                                }
                            >
                                {msg.content}
                            </div>
                        ))}
                    </div>

                    <div className="slai-chat-input-row">
                        <input
                            type="text"
                            placeholder="Type your question..."
                            value={messageInput}
                            onChange={(e) => setMessageInput(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSend();
                            }}
                        />
                        <button onClick={handleSend}>Send</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default AskSLAI;
